import React, {useCallback, useEffect, useState} from "react";
import { graphql, useStaticQuery } from "gatsby";

const CustomPopup = () => {
    const { allWp } = useStaticQuery(graphql`
        query CustomPopup {
            allWp {
                nodes {
                    customPopup {
                        acfCustomPopup {
                            description
                            enablePopup
                            image {
                                altText
                                localFile {
                                    childImageSharp {
                                        gatsbyImageData(layout: FULL_WIDTH, placeholder: DOMINANT_COLOR)
                                    }
                                }
                            }
                            link {
                                target
                                title
                                url
                            }
                            showAfter
                            title
                        }
                    }
                }
            }
        }
    `);
    const acfCustomPopup = allWp?.nodes?.[0]?.customPopup?.acfCustomPopup;
    const enablePopup = acfCustomPopup?.enablePopup;
    const showAfter = acfCustomPopup?.showAfter;

    const [showPopup, setShowPopup] = useState(false);
    const [PopupContent, setPopupContent] = useState(null);

    const handleClose = useCallback(() => {
        sessionStorage.setItem("CustomPopup", "shown");
        setShowPopup(false);
    }, []);

    useEffect(() => {
        if (!enablePopup || sessionStorage.getItem("CustomPopup") === "shown") {
            return;
        }

        let cancelled = false;
        const timer = window.setTimeout(() => {
            // Keep the modal and its animation dependencies out of the initial graph.
            import("./CustomPopupContent")
                .then(({ default: Content }) => {
                    if (!cancelled && sessionStorage.getItem("CustomPopup") !== "shown") {
                        setPopupContent(() => Content);
                        setShowPopup(true);
                    }
                })
                .catch(error => console.error("Failed to load custom popup", error));
        }, Math.max(0, Number(showAfter) || 0) * 1000);

        return () => {
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, [enablePopup, showAfter]);

    return (
        // Keep the loaded modal mounted after closing so its exit animation can finish.
        PopupContent && enablePopup ? (
            <PopupContent
                settings={acfCustomPopup}
                isOpened={showPopup}
                onClose={handleClose}
            />
        ) : null
    );
}

export default CustomPopup;
